import { render } from "./bottomCta.vue?vue&type=template&id=40624919&scoped=true"
import script from "./bottomCta.vue?vue&type=script&lang=js"
export * from "./bottomCta.vue?vue&type=script&lang=js"

import "./bottomCta.vue?vue&type=style&index=0&id=40624919&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40624919"]])

export default __exports__